import { render } from "./leftmenu.vue?vue&type=template&id=ad24d0b2"
import script from "./leftmenu.vue?vue&type=script&lang=js"
export * from "./leftmenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__